import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Badge = ({
  children,
  className: classNameProp,
  component: Component,
  variant,
  ...other
}) => {
  const className = classNames(
    'campus-badge',
    {
      [`campus-badge--${variant}`]: variant,
    },
    classNameProp
  )
  return (
    <Component className={className} {...other} >
      {children}
      <style jsx>
        {`
          .campus-badge{
            position: relative;
            display: inline-flex;
            padding: 8px;
            border-radius: 4px;
            &--default {
              background-color: #485C77;
              color: #fff;
            }
            &--red {
              font-size: 10px;
              padding: 2px 4px;
              line-height: 14px;
              font-weight: bold;
              background-color: #ff5252;
              color: #fff;
            }
          }
        `}
      </style>
    </Component>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  component: PropTypes.node,
  variant: PropTypes.string,
}

Badge.defaultProps = {
  component: 'span',
  variant: 'default',
}

export default Badge
